/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShareClaimRequestOneOf2
 */
export interface ShareClaimRequestOneOf2 {
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf2
     */
    type: ShareClaimRequestOneOf2TypeEnum;
    /**
     * Email address of the user to share with (for cross-company sharing)
     * @type {string}
     * @memberof ShareClaimRequestOneOf2
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimRequestOneOf2
     */
    level?: ShareClaimRequestOneOf2LevelEnum;
    /**
     * 
     * @type {Array<object>}
     * @memberof ShareClaimRequestOneOf2
     */
    blockedModules?: Array<object>;
    /**
     * False or omitted for an ordinary email share.
     * @type {boolean}
     * @memberof ShareClaimRequestOneOf2
     */
    isAppraisalRequest?: boolean;
}


/**
 * @export
 */
export const ShareClaimRequestOneOf2TypeEnum = {
    Email: 'email'
} as const;
export type ShareClaimRequestOneOf2TypeEnum = typeof ShareClaimRequestOneOf2TypeEnum[keyof typeof ShareClaimRequestOneOf2TypeEnum];

/**
 * @export
 */
export const ShareClaimRequestOneOf2LevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ShareClaimRequestOneOf2LevelEnum = typeof ShareClaimRequestOneOf2LevelEnum[keyof typeof ShareClaimRequestOneOf2LevelEnum];


/**
 * Check if a given object implements the ShareClaimRequestOneOf2 interface.
 */
export function instanceOfShareClaimRequestOneOf2(value: object): value is ShareClaimRequestOneOf2 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ShareClaimRequestOneOf2FromJSON(json: any): ShareClaimRequestOneOf2 {
    return ShareClaimRequestOneOf2FromJSONTyped(json, false);
}

export function ShareClaimRequestOneOf2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimRequestOneOf2 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'email': json['email'],
        'level': json['level'] == null ? undefined : json['level'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
        'isAppraisalRequest': json['isAppraisalRequest'] == null ? undefined : json['isAppraisalRequest'],
    };
}

export function ShareClaimRequestOneOf2ToJSON(json: any): ShareClaimRequestOneOf2 {
    return ShareClaimRequestOneOf2ToJSONTyped(json, false);
}

export function ShareClaimRequestOneOf2ToJSONTyped(value?: ShareClaimRequestOneOf2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'email': value['email'],
        'level': value['level'],
        'blockedModules': value['blockedModules'],
        'isAppraisalRequest': value['isAppraisalRequest'],
    };
}

